import Loginform from './loginForm';
import { SIZE } from './constants';

export default Loginform;
export { SIZE };